// extracted by mini-css-extract-plugin
export default {"mainWrapper":"DuplicategrowthArea_mainWrapper__fOvmZ","editInnerWrapper":"DuplicategrowthArea_editInnerWrapper__8twrA","editText":"DuplicategrowthArea_editText__TGFsC"};